// extracted by mini-css-extract-plugin
module.exports =  {"root":"jlU0G74tpKAZXM80EZCg","dimensions":"IV5hdp4whf6tM1RxLhKK","chip":"F6yIZPBp9khOFgKLlIgh"};